import React from 'react';
import { X, Check } from 'lucide-react';

const ComparisonCard = ({ category, themTitle, themDescription, amplifyTitle, amplifyDescription }) => (
  <div className="comparison-card">
    <div className="comparison-card-label">{category}</div>
    <div className="comparison-card-split">
      <div className="comparison-side comparison-them">
        <X size={48} className="comparison-icon" />
        <div className="comparison-title">{themTitle}</div>
        <div className="comparison-description">{themDescription}</div>
      </div>
      <div className="comparison-divider"></div>
      <div className="comparison-side comparison-amplify">
        <Check size={48} className="comparison-icon" />
        <div className="comparison-title">{amplifyTitle}</div>
        <div className="comparison-description">{amplifyDescription}</div>
      </div>
    </div>
  </div>
);

const SolutionSection = () => (
  <section className="solution-section">
    <div className="section-container">
      <h2 className="section-headline">The Service-First PEO Model</h2>
      <p className="section-intro">
        Stop managing HR through a ticket queue. Amplify HR pairs you with a dedicated team, transparent itemized pricing, and rapid response accountability so you get answers fast and stay in control of costs. Quotes in days, not weeks.
      </p>
      <div className="signature-accent"></div>
      <h3 className="comparison-subheadline">Big-Box PEO vs. Amplify HR</h3>
      
      <div className="comparison-cards">
        <ComparisonCard
          category="SUPPORT"
          themTitle="Them"
          themDescription="Long resolution times and high turnover positions"
          amplifyTitle="Amplify"
          amplifyDescription="Rapid response and tenured team you can rely on"
        />
        <ComparisonCard
          category="PRICING"
          themTitle="Them"
          themDescription="Hidden fees and opaque billing"
          amplifyTitle="Amplify"
          amplifyDescription="Transparent, itemized pricing"
        />
        <ComparisonCard
          category="SPEED"
          themTitle="Them"
          themDescription="Multi day queues for urgent issues and slow quoting"
          amplifyTitle="Amplify"
          amplifyDescription="Quotes in days, rapid response with clear accountability"
        />
        <ComparisonCard
          category="BENEFITS"
          themTitle="Them"
          themDescription="One size fits all. Typically captive to just one carrier and lack of options"
          amplifyTitle="Amplify"
          amplifyDescription="Any carrier, any plan, alternative options"
        />
      </div>

      <div className="comparison-table">
        <table>
          <thead>
            <tr>
              <th>What Matters</th>
              <th>Big-Box PEOs</th>
              <th>Amplify HR</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Support Model</td>
              <td>
                <div className="table-cell-content">
                  <X size={20} className="table-icon-bad" />
                  <span>Call centers and ticket queues</span>
                </div>
              </td>
              <td>
                <div className="table-cell-content">
                  <Check size={20} className="table-icon-good" />
                  <span>Dedicated team with direct access</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>Pricing</td>
              <td>
                <div className="table-cell-content">
                  <X size={20} className="table-icon-bad" />
                  <span>Hidden fees and opaque billing</span>
                </div>
              </td>
              <td>
                <div className="table-cell-content">
                  <Check size={20} className="table-icon-good" />
                  <span>Transparent, itemized pricing</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>Response Time</td>
              <td>
                <div className="table-cell-content">
                  <X size={20} className="table-icon-bad" />
                  <span>Days for answers</span>
                </div>
              </td>
              <td>
                <div className="table-cell-content">
                  <Check size={20} className="table-icon-good" />
                  <span>Rapid response with accountability</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>Rep Turnover</td>
              <td>
                <div className="table-cell-content">
                  <X size={20} className="table-icon-bad" />
                  <span>New rep every 6 months</span>
                </div>
              </td>
              <td>
                <div className="table-cell-content">
                  <Check size={20} className="table-icon-good" />
                  <span>Consistent team that knows your business</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>Benefits Flexibility</td>
              <td>
                <div className="table-cell-content">
                  <X size={20} className="table-icon-bad" />
                  <span>Captive to single program</span>
                </div>
              </td>
              <td>
                <div className="table-cell-content">
                  <Check size={20} className="table-icon-good" />
                  <span>Proprietary benefits across multiple carriers: FirstAdvantage™ zero deductible program, ICHRA, and MERP</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <p className="solution-closing">
        If your current big box PEO feels bigger than your business, Amplify HR is the alternative.
      </p>
    </div>
  </section>
);

export default SolutionSection;
